<template>
    <div class="toggle" :class="{ 'toggle--small': isSmall, '!tw-pointer-events-none': disabled }" :for="theId">
        <span class="toggle__container">
            <input
                :id="theId"
                v-model="theValue"
                :disabled="disabled"
                :checked="checked"
                type="checkbox"
                class="toggle__checkbox"
                @change="handleCheck"
            >
            <span class="toggle__pill"></span>
        </span>
        <label class="toggle__label">
            <slot></slot>
        </label>
    </div>
</template>

<script>
import { uniqueId } from 'lodash';

export default {
    name: 'DkToggle',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: null,
        },
        isSmall: {
            type: Boolean,
            default: false,
        },
        checked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: [String, null],
            default: null,
        },
    },
    data() {
        return {
            theValue: this.value,
            uId: uniqueId(),
        };
    },
    computed: {
        theId() {
            return this.id ? this.id : this.uId;
        },
    },
    methods: {
        handleCheck() {
            this.$emit('input', this.theValue);
            this.$emit('change', this.theValue);
        },
    },
};
</script>
